import './scripts/global';
import './scripts/navigation/navigation';
import './scripts/blocks/component-carousel';
import './scripts/blocks/component-picture';
import './scripts/blocks/component-accordion';
import './scripts/blocks/component-video';
import './scripts/blocks/component-tabs';
import './scripts/blocks/block-carousel';
import './scripts/blocks/block-banner';
import './scripts/blocks/block-package';
import './scripts/blocks/acf-blocks-container';